class ProductDiscountBadge extends HTMLElement {
  constructor() {
    super();
    this.discountCode = null; // Placeholder for discount code
    this.badge = null; // Reference to the badge element
  }

  connectedCallback() {
    this.initBadge();
  }

  initBadge() {
    this.discountCode = CookiesHelper.get('discount_code');
    if (this.discountCode) {
      this.adjustPrice();
      this.showBadge();
      this.hidePaymentTerms()
    } else {
      this.hidden = true  // Hide the badge if no discount code exists
    }
  }

  adjustPrice() {
    const adjustedDiscountCode = this.discountCode.replace('+', ' ');
    this.discountText = adjustedDiscountCode;

    const priceEl = this.parentElement.querySelector('[data-pprice]');
    if (!priceEl) return;

    const parsedPriceArray = priceEl.textContent.replace(/,/g, '').match(/\d+(\.\d+)?/g);
    if (!parsedPriceArray) return;

    const parsedPrice = parseFloat(parsedPriceArray.join('.'));
    if (!parsedPrice) return;

    const discountData = window.__d_metafields_data;
    if (!discountData) return;

    const discount = discountData.find((item) => item.title === adjustedDiscountCode);
    if (!discount) return;
    // const currencySymbol = priceEl.textContent.match(/[^0-9.,]/g)[0];
    const currencySymbol = Shopify.currency._symbol;

    if (discount['fixed'] && discount.entire) {
      this.discountText = `${this.discountText} (-${currencySymbol}${(discount.value * Shopify.currency.rate).toFixed(2)}) will be applied for entire order.`
      return
    }

    const priceAfterDiscount = parsedPrice * (1 - discount.value / 100);
    const discountPriceValue = parsedPrice - priceAfterDiscount;

    this.discountText = `${this.discountText} (-${currencySymbol}${discountPriceValue.toFixed(2)}) has been applied.`

    priceEl.innerHTML = `<s style="font-size: .7em; font-weight: normal;">${currencySymbol}${parsedPrice.toFixed(2)}</s> ${currencySymbol}${priceAfterDiscount.toFixed(2)}`;
  }

  hidePaymentTerms() {
    document.querySelectorAll('.product-info__block-item[data-block-id="payment_terms"]').forEach((paymentTerm) => {
      paymentTerm.hidden = true
    })
  }

  showBadge() {
    this.badge = this.querySelector('[data-discount-title]');
    if (this.badge) {
      // Insert the discount code dynamically into the badge
      this.badge.textContent = this.discountText;
    }

    // Ensure the badge is visible
    this.hidden = false;
  }
}

if (!customElements.get('product-discount-badge')) {
  customElements.define('product-discount-badge', ProductDiscountBadge);
}